<template>
  <vue-scroll class="table-download-page">
    <bCardHeader :param="param" class="card-header"></bCardHeader>
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <el-row >
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <table-card :params="oneParams"></table-card>
          </el-col>
          <el-col class="mt-10" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <table-card :params="twoParams"></table-card>
          </el-col>
        </el-row>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <table-card :params="threeParams"></table-card>
      </el-col>
    </el-row>
  </vue-scroll>
</template>

<script>
import tableCard from './card.vue'
export default {
  data () {
    return {
      param: {
        title: 'table-download',
        links: [
          { title: 'home' },
          { title: 'my_account' },
          { title: 'table-download' }
        ]
      }
    }
  },
  computed: {
    oneParams () {
      return this.$t('tableDownload.oneParams')
    },
    twoParams () {
      return this.$t('tableDownload.twoParams')
    },
    threeParams () {
      return this.$t('tableDownload.threeParams')
    }
  },
  components: {
    tableCard
  }
}
</script>

<style scoped>
</style>
